export default "__VITE_ASSET__BQsD1tm$__"